export let Subdomain;
(function (Subdomain) {
  Subdomain["Br"] = "br";
})(Subdomain || (Subdomain = {}));